<mat-dialog-content class="mat-typography">
	<div class='branding--terms-and-conditions-dialog--content' [innerHTML]='data.safeHtmlContent'></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button [mat-dialog-close]="true" cdkFocusInitial *ngIf="!data.useAccept">{{ "ACTION_BUTTON_LABELS.CLOSE" | translate }}</button>
	<button mat-button [mat-dialog-close]="true" cdkFocusInitial *ngIf="data.useAccept">{{ "ACTION_BUTTON_LABELS.ACCEPT" | translate }}</button>
</mat-dialog-actions>
